import { loadTokens } from "./auth";

function ApplicationCard({ application }) {
  const Icon = application.icon;

  const handleLaunch = () => {
    const tokens = loadTokens();
    let targetUrl = application.url;

    if (tokens?.accessToken) {
      const separator = targetUrl.includes("#") ? "&" : "#";
      targetUrl = `${targetUrl}${separator}access_token=${encodeURIComponent(
        tokens.accessToken
      )}`;
    }

    const link = document.createElement("a");
    link.href = targetUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div className="application-card">

      <div className="card-icon">
        <Icon />
      </div>

      <div className="card-content">
        <h2>{application.title}</h2>

        <p>
          {application.description}
        </p>
      </div>

      <button
        className="launch-button"
        onClick={handleLaunch}
      >
        LAUNCH
      </button>

    </div>
  );
}

export default ApplicationCard;